import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { initAccordions } from "flowbite";
import Leftsidebar from "../components/sidebar/leftsidebar";
import LeftResponsivesidebar from "../components/sidebar/left-responsive";
import Rightsidebar from "../components/sidebar/rightsidebar";
import RightResponsivesidebar from "../components/sidebar/right-responsive";
import Headmenu from "../components/sidebar/headmenu";
import { Switch } from "@headlessui/react";
import { ChevronUp } from "lucide-react";
import userimg from "../assets/user.png";
import { X, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "react-toastify";
import VerificationModal from "./verificationmodal";
import pipaanlogo from "../assets/pipaanlogo.svg";
import MyPlansCard from "./subscription/MyPlansCard";
import DeleteAccountModal from "./DeleteAccountModal";
import { CMS_SLUGS, CmsHtml, useCmsPage } from "./legal/cmsContent";
import { formatDateOnly } from "../utils/date";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const AccordionItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="policy-title border border-gray-200 rounded-lg overflow-hidden">
      <button
        className="flex justify-between items-center w-full p-5 text-gray-700 bg-white hover:bg-gray-200"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-left w-full">{title}</span>
        <ChevronUp
          className={`h-5 w-5 ChevronUp transition-transform ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        />
      </button>
      {isOpen && (
        <div className="p-5 bg-white border-t border-gray-200">{children}</div>
      )}
    </div>
  );
};

// Mounted only while its accordion item is open, so each document loads when first opened
const LegalDocumentPreview = ({ slug, path }) => {
  const navigate = useNavigate();
  const { status, page, reload } = useCmsPage(slug);

  if (status === "error") {
    return (
      <div className="text-sm text-red-600">
        This page isn't available right now.{" "}
        <button type="button" onClick={reload} className="underline font-medium">
          Try again
        </button>
      </div>
    );
  }
  if (status !== "ready") return <p className="text-sm text-gray-500">Loading...</p>;

  return (
    <>
      {page.updated_at && (
        <p className="text-xs text-gray-500 mb-3">Last updated {formatDateOnly(page.updated_at)}</p>
      )}
      <CmsHtml html={page.content} className="max-h-[50vh] overflow-y-auto pr-2" />
      <button
        type="button"
        onClick={() => navigate(path)}
        className="mt-4 text-sm font-semibold text-[#095228] underline"
      >
        View full page
      </button>
    </>
  );
};

export default function Account() {
  useEffect(() => {
    initAccordions();
  }, []);

  // const [isPrivate, setIsPrivate] = useState(false);
  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isTwoFactorOpen, setIsTwoFactorOpen] = useState(true);
  const [isBlockedOpen, setIsBlockedOpen] = useState(true);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(true);
  const [isPolicyOpen, setIsPolicyOpen] = useState(true);
  const [isDeleteAccountOpen, setIsDeleteAccountOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("+91 79043 30323");
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("email"); // Default: email
  const [code, setCode] = useState("");
  const [timer, setTimer] = useState(300); // 5 minutes (300 seconds)
  const navigate = useNavigate(); // Hook for navigation
  const privacyFromSession = JSON.parse(
    sessionStorage.getItem("privacySettings") ||
      localStorage.getItem("privacySettings") ||
      "{}"
  );
  const privacyStatusFromSession =
    sessionStorage.getItem("privacyStatus") ||
    localStorage.getItem("privacyStatus");
  const [isPrivate, setIsPrivate] = useState(
    privacyStatusFromSession === "private"
  );

  const [privacySettings, setPrivacySettings] = useState({
    phone_privacy: privacyFromSession?.phone_privacy || "public",
    email_privacy: privacyFromSession?.email_privacy || "public",
    follower_privacy: privacyFromSession?.follower_privacy || "public",
    post_privacy: privacyFromSession?.post_privacy || "public",
    story_privacy: privacyFromSession?.story_privacy || "public",
    tag_privacy: privacyFromSession?.tag_privacy || "public",
    online_privacy: privacyFromSession?.online_privacy || "public",
  });
  // Add these to your component state
  const [newMobile, setNewMobile] = useState("");
  const [isSavingMobile, setIsSavingMobile] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [otpError, setOtpError] = useState("");
  const [profile, setProfile] = useState({});
  const [newEmail, setNewEmail] = useState("");
  const [isSavingEmail, setIsSavingEmail] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [showEmailOTPModal, setShowEmailOTPModal] = useState(false);
  const [emailOtpCode, setEmailOtpCode] = useState("");
  const [emailOtpError, setEmailOtpError] = useState("");
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const privacyId = privacyFromSession?.id; // This is the id you need for editing
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [mobileNumber, setMobileNumber] = useState("");

  useEffect(() => {
    if (profile?.mobile_number) {
      const match = profile.mobile_number.match(/^(\+\d+)\s*(.*)$/);
      if (match) {
        setCountryCode(match[1]); // +91
        setMobileNumber(match[2].replace(/\D/g, "")); // 8319108497
      }
    }
  }, [profile]);

  useEffect(() => {
    const fetchPrivacyStatus = async () => {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");
      const user = JSON.parse(
        sessionStorage.getItem("user") || localStorage.getItem("user") || "{}"
      );
      if (!token || !user?.id) return;
      try {
        const response = await fetch(
          `${API_BASE_URL}/user/get-privacy`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              token,
            },
            body: JSON.stringify({
              filters: { user_id: user.id },
              page: 1,
              limit: 10,
            }),
          }
        );
        const data = await response.json();
        if (data.success && data.result) {
          // Try to get privacy_status from result, fallback to user object
          let status = data.result.privacy_status;
          if (!status && user.privacy_status) status = user.privacy_status;
          if (!status) status = "public";
          setIsPrivate(status === "private");
          sessionStorage.setItem("privacyStatus", status);
          localStorage.setItem("privacyStatus", status);
        }
      } catch (err) {
        console.error("Failed to fetch privacy status:", err);
      }
    };
    fetchPrivacyStatus();
  }, []);
  // Optionally, fetch from API if sessionStorage is empty
  useEffect(() => {
    if (!privacyFromSession?.id) {
      const fetchPrivacy = async () => {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");
        const user = JSON.parse(
          sessionStorage.getItem("user") || localStorage.getItem("user") || "{}"
        );
        if (!token || !user?.id) return;
        try {
          const response = await fetch(
            `${API_BASE_URL}/user/get-privacy`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                token,
              },
              body: JSON.stringify({
                filters: { user_id: user.id },
                page: 1,
                limit: 10,
              }),
            }
          );
          const data = await response.json();
          if (data.success && data.result) {
            setPrivacySettings({
              phone_privacy: data.result.phone_privacy,
              email_privacy: data.result.email_privacy,
              follower_privacy: data.result.follower_privacy,
              post_privacy: data.result.post_privacy,
              story_privacy: data.result.story_privacy,
              tag_privacy: data.result.tag_privacy,
              online_privacy: data.result.online_privacy,
            });
            sessionStorage.setItem(
              "privacySettings",
              JSON.stringify(data.result)
            );
            localStorage.setItem(
              "privacySettings",
              JSON.stringify(data.result)
            );
          }
        } catch (err) {
          console.error("Failed to fetch privacy settings:", err);
        }
      };
      fetchPrivacy();
    }
  }, []);

  const handlePrivacyChange = async (field, value) => {
    // Update local state
    const updatedSettings = { ...privacySettings, [field]: value };
    setPrivacySettings(updatedSettings);

    // Prepare API body - only the known privacy fields, since updatedSettings
    // can carry extra fields (id, user_id, created_at, ...) once privacySettings
    // has been set from a previous save's full DB row, which fails backend validation
    const body = {
      phone_privacy: updatedSettings.phone_privacy,
      email_privacy: updatedSettings.email_privacy,
      follower_privacy: updatedSettings.follower_privacy,
      post_privacy: updatedSettings.post_privacy,
      story_privacy: updatedSettings.story_privacy,
      tag_privacy: updatedSettings.tag_privacy,
      online_privacy: updatedSettings.online_privacy,
    };

    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");
      const response = await fetch(
        `${API_BASE_URL}/user/add-edit-privacy`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify(body),
        }
      );

      const data = await response.json();
      if (response.ok && data.success) {
        // save in sessionStorage
        sessionStorage.setItem("privacySettings", JSON.stringify(data.result));
        localStorage.setItem("privacySettings", JSON.stringify(data.result));
        if (data.result.id) {
          sessionStorage.setItem("privacyId", data.result.id);
          localStorage.setItem("privacyId", data.result.id);
        }
        setPrivacySettings(data.result);
        console.log("✅ Privacy saved/updated");
      } else {
        // Show the saved value again, not the one the API refused
        setPrivacySettings(privacySettings);
        alert(
          "Failed to save privacy: " + (data.message || "Unknown error")
        );
      }
    } catch (error) {
      setPrivacySettings(privacySettings);
      alert("Error saving privacy: " + error.message);
    }
  };

  const handleInfluencerToggle = async () => {
    getverified(true);
  };

  const handlePrivacyToggle = async (checked) => {
    setIsPrivate(checked);
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/user/add-edit-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            privacy_status: checked ? "private" : "public",
          }),
        }
      );
      const data = await response.json();
      if (response.ok && data.success) {
        sessionStorage.setItem("privacyStatus", checked ? "private" : "public");
        localStorage.setItem("privacyStatus", checked ? "private" : "public");
      } else {
        alert("Failed to update privacy status");
      }
    } catch (error) {
      alert("Error updating privacy status: " + error.message);
    }
  };
  const [formData, setFormData] = useState({
    mobile: "",
    countryCode: "+91", // Default country code
  });
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [followings, setFollowings] = useState([]);

  useEffect(() => {
    fetchBlockedUsers();
  }, []);

  const fetchBlockedUsers = async () => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/friend/get-friends`,
        {
          filters: { isBlockedUsers: true },
          page: 1,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token,
          },
        }
      );

      if (response?.data?.success) {
        const friends = response.data.result.friends || [];
        setBlockedUsers(friends);

        // ✅ Store mapping for later use in unblock
        const map = {};
        friends.forEach((f) => {
          map[f.id] = f.User2?.id;
        });
        sessionStorage.setItem("user2IdMap", JSON.stringify(map));
        localStorage.setItem("user2IdMap", JSON.stringify(map));
      }
    } catch (error) {
      console.error("Failed to fetch blocked users:", error);
    }
  };

  const handleUnblock = async (friendId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    // ✅ Show confirmation popup
    const isConfirmed = window.confirm(
      "Are you sure you want to unblock this user?"
    );
    if (!isConfirmed) return; // Stop execution if user cancels
    // ✅ Retrieve the user2id from sessionStorage
    const user2IdMap =
      JSON.parse(
        sessionStorage.getItem("user2IdMap") ||
          localStorage.getItem("user2IdMap") ||
          {}
      ) || {};

    // Get the corresponding user2id from the friendId
    const user2id = user2IdMap[friendId];

    if (!user2id) {
      console.error(`User2 ID not found for friend ID: ${friendId}`);
      return;
    }
    try {
      const response = await fetch(
        `${API_BASE_URL}/friend/add-friend`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
          body: JSON.stringify({
            status: "unblock", // ✅ Use "blocked" status
            user_id: user2id,
          }),
        }
      );

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      console.log(`✅ Unblocked user ID: ${friendId}`);
      window.location.reload();
      // ✅ Update UI to show Follow/Block buttons again
      setFollowings((prev) =>
        prev.map((user) =>
          user.id === friendId ? { ...user, isBlocked: false } : user
        )
      );
    } catch (error) {
      console.error("❌ Error unblocking:", error);
    }
  };
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const fetchUserProfile = async () => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken"); // Retrieve token
    console.log("Retrieved Token in home page:", token); // ✅ Log token to verify

    if (!token) {
      console.log("Token not found, waiting...");
      setError("Authentication token not found!");
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/user/profile`,
        {
          method: "GET",
          headers: {
            token: `${token}`, // ✅ Ensure proper format
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      console.log("API Response Status:", response.status); // ✅ Log status
      console.log("✅ API Success Response from profile page:", data); // ✅ Log full response
      setUserData(data.result);
    } catch (err) {
      console.error("❌ Fetch API Error:", err);
      setError("An error occurred while fetching the profile");
    }
  };
  useEffect(() => {
    fetchUserProfile();
  }, []); // ✅ Keep useEffect dependency empty

  //Influencer Switch
  const [isInfluencer, setIsInfluencer] = useState(
    profile?.verificationBadges?.influencer || false
  );
  const [openModal, getverified] = useState(false);
  const [isEligible, setIsEligible] = useState(false);
  const [influencerStatus, setInfluencerStatus] = useState(null);

  const fetchVerificationStatus = async () => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (!token) {
      console.error("No token found for verification status");
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/verification/status`,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data) {
        response.data = response.data.result;
        setIsEligible(response.data.eligible);
        const influencer = response.data.verificationStatus?.influencer || null;
        setInfluencerStatus(influencer);
        setIsInfluencer(influencer?.status === "approved");
      }
    } catch (error) {
      console.error("Error fetching verification status:", error);
    }
  };
  useEffect(() => {
    fetchVerificationStatus();
  }, []);

  // Inside Account component (Account.js)

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isSavingPassword, setIsSavingPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [passwordCriteria, setPasswordCriteria] = useState({
    minLength: false,
    alphanumeric: false,
    specialChar: false,
  });

  const validateNewPassword = (value) => {
    setNewPassword(value);
    setPasswordCriteria({
      minLength: value.length >= 8,
      alphanumeric: /[a-zA-Z]/.test(value) && /[0-9]/.test(value),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value),
    });
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setIsSavingPassword(true);
    setPasswordError("");

    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token || !currentPassword || !newPassword) {
      setPasswordError("Please enter your current and new password.");
      setIsSavingPassword(false);
      return;
    }

    if (
      !passwordCriteria.minLength ||
      !passwordCriteria.alphanumeric ||
      !passwordCriteria.specialChar
    ) {
      setPasswordError("Password must meet all the criteria below.");
      setIsSavingPassword(false);
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/change-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            old_password: currentPassword,
            new_password: newPassword,
          }),
        }
      );

      const data = await response.json();
      if (response.ok && data.success) {
        toast.success("Password updated successfully!");
        setIsPasswordModalOpen(false);
        setCurrentPassword("");
        setNewPassword("");
        setPasswordCriteria({
          minLength: false,
          alphanumeric: false,
          specialChar: false,
        });
      } else {
        setPasswordError(data.result?.message || data.message || "Failed to update password.");
      }
    } catch (error) {
      setPasswordError("Error updating password. Please try again.");
    }
    setIsSavingPassword(false);
  };

  // Format time as MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };
  const handleSendMobileOTP = async (e) => {
    e.preventDefault();

    if (!formData.mobile) {
      toast.success("Please enter your mobile number.");
      return;
    }

    const formattedMobile = `${formData.countryCode}-${formData.mobile}`;

    const requestData = { mobile_number: formattedMobile };

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/send-otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (response.ok && data.success) {
        toast.success(
          `OTP has been sent to your mobile number: ${formattedMobile}`
        );
      } else {
        alert(
          `Failed to send OTP: ${data.result?.message || "Please try again."}`
        );
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  const handleSubmitVerify = async (e) => {
    e.preventDefault();
    const storedEmail = sessionStorage.getItem("userEmail");
    if (!storedEmail) {
      alert("No email found. Please sign up again.");
      return;
    }
    const requestData = {
      email: storedEmail, // Email entered by the user
      otp: code,
      verifying: "mobile_number", // Verification code entered by the user
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/verify-credential`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        console.log("Verification Successful:", data);
        toast.success("Verification Successful! Please log in.");

        // Redirect to login page
        navigate("/login");
      } else {
        console.error("Verification Failed:", data);
        alert(
          `Verification failed: ${
            data.result?.message || "Invalid code. Please try again."
          }`
        );
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  const handleGenerateOTP = async (e) => {
    e.preventDefault();

    if (!formData.mobile) {
      toast.success("Please enter your mobile number.");
      return;
    }

    const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
    const requestData = { mobile_number: formattedMobile };

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/send-otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (response.ok && data.success) {
        toast.success(
          `OTP has been sent to your mobile number: ${formattedMobile}`
        );
      } else {
        alert(
          `Failed to send OTP: ${data.result?.message || "Please try again."}`
        );
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (!formData.mobile) {
      toast.success("Please enter your mobile number.");
      return;
    }
    if (!code) {
      toast.success("Please enter the OTP.");
      return;
    }
    const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
    const requestData = {
      email: formattedMobile, // API expects "email", but we're passing the mobile number
      otp: code,
      verifying: "mobile_number",
      // Include the OTP entered by the user
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/verify-credential`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (response.ok && data.success) {
        toast.success("Verification Successful! Please log in.");
        navigate("/login"); // Redirect after successful verification
      } else {
        alert(
          `Verification failed: ${
            data.result?.message || "Invalid code. Please try again."
          }`
        );
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const users = JSON.parse(
    sessionStorage.getItem("user") || localStorage.getItem("user")
  );
  useEffect(() => {
    const number = profile?.mobile_number || users?.mobile_number;
    if (number) {
      const match = number.match(/^(\+\d+)[\s-]?(.*)$/);
      if (match) {
        setCountryCode(match[1]); // +91
        setPhone(match[2].replace(/\D/g, ""));
      }
    }
  }, [profile, users]);

  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <div className="h-full menu-bar-left">
        <Leftsidebar />
      </div>
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        {/* Main Content */}
        <main className="block lg:grid lg:grid-cols-[78%_20%]">
          {/* Feeds */}
          <div className="md:px-5 space-y-6">
            <div className="account-setting mx-auto ">
              <MyPlansCard />
              <div className="mt-6 p-4 md:p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                <h2 className="text-lg font-semibold mb-4">Account Settings</h2>
                <button
                  className="absolute top-4 right-4 md:top-8 md:right-8 p-1 bg-[#09522869] rounded-full"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <ChevronUp
                    className={`h-4 w-4 text-[#095228] transition-transform ${
                      isOpen ? "rotate-0" : "rotate-180"
                    }`}
                  />
                </button>

                {isOpen && (
                  <>
                    <div className="space-y-3">
                      <span className="text-gray-500 block md:hidden">
                        Phone Number
                      </span>
                      <div className="bg-white p-3 md:p-5 rounded-[12px] flex justify-between items-center shadow-sm">
                        <div className="flex">
                          <span className="text-gray-500 w-[200px] tab-title">
                            Phone Number
                          </span>
                          <div className="text-black font-[400] flex items-center">
                            {(
                              profile?.mobile_number ||
                              users?.mobile_number ||
                              "+91-XXXX-XXXXXX"
                            ).replace(/-/g, " ")}
                            <span className="ml-1 text-green-500">
                              <span className="w-4 h-4 bg-green-500 text-white rounded-full flex items-center justify-center">
                                <Check className="w-3 h-3" />
                              </span>
                            </span>
                          </div>
                        </div>
                        {/* Change Button */}
                        <button
                          onClick={() => setIsModalOpen(true)}
                          className="text-[#000000] italic underline text-sm"
                        >
                          Change
                        </button>

                        {isModalOpen && (
                          <div className="fixed inset-0 flex items-center justify-center bg-[#fff] backdrop-blur bg-opacity-50 z-[9999]">
                            <div className="bg-white p-6 md:pl-[8%] md:pr-[8%] md:pb-[6%] rounded-2xl shadow-lg relative">
                              <button
                                className="hidden md:block absolute top-6 right-6 text-[#fff] hover:text-[#fff] bg-[#095228] rounded-full p-1 pl-2.5 pr-2.5"
                                onClick={() => setIsModalOpen(false)}
                              >
                                ✖
                              </button>
                              <h2 className="login-title text-base font-medium text-center mt-2 mb-6 px-8">
                                Change Mobile Number
                              </h2>
                              <form
                                onSubmit={async (e) => {
                                  e.preventDefault();
                                  setIsSavingMobile(true);
                                  setMobileError("");
                                  const token =
                                    sessionStorage.getItem("accessToken") ||
                                    localStorage.getItem("accessToken");
                                  const user = JSON.parse(
                                    sessionStorage.getItem("user") ||
                                      localStorage.getItem("user") ||
                                      "{}"
                                  );
                                  const fullMobileNumber = `${countryCode}-${mobileNumber}`;

                                  if (mobileNumber.length < 7 || !user?.id) {
                                    setMobileError(
                                      "Please enter a valid mobile number."
                                    );
                                    setIsSavingMobile(false);
                                    return;
                                  }

                                  try {
                                    // 1. Update mobile number
                                    const response = await fetch(
                                      `${API_BASE_URL}/user/edit-mobile-email`,
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          token,
                                        },
                                        body: JSON.stringify({
                                          // user_id: user.id,
                                          mobile_number: fullMobileNumber,
                                        }),
                                      }
                                    );
                                    const data = await response.json();
                                    if (response.ok && data.success) {
                                      // 2. Fetch profile to get new_mobile_number
                                      const profileRes = await fetch(
                                        `${API_BASE_URL}/user/profile`,
                                        {
                                          method: "GET",
                                          headers: {
                                            "Content-Type": "application/json",
                                            token,
                                          },
                                        }
                                      );
                                      const profileData =
                                        await profileRes.json();
                                      if (
                                        profileData.success &&
                                        profileData.result
                                      ) {
                                        setProfile(profileData.result); // Save profile with new_mobile_number
                                        setShowOTPModal(true); // Show OTP modal
                                        setIsModalOpen(false); // Close mobile change modal
                                      } else {
                                        setMobileError(
                                          "Failed to fetch updated profile."
                                        );
                                      }
                                    } else {
                                      setMobileError(
                                        data.result?.message ||
                                          "Failed to update mobile number."
                                      );
                                    }
                                  } catch (error) {
                                    setMobileError(
                                      "Error updating mobile number."
                                    );
                                  }
                                  setIsSavingMobile(false);
                                }}
                                className="space-y-4"
                              >
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                  Enter new mobile number
                                </label>

                                <div className="flex gap-2">
                                  <select
                                    value={countryCode}
                                    onChange={(e) =>
                                      setCountryCode(e.target.value)
                                    }
                                    className="border border-gray-300 rounded-lg px-3 py-2 bg-white"
                                  >
                                    <option value="+91">🇮🇳 +91 (India)</option>
                                    <option value="+1">🇺🇸 +1 (USA)</option>
                                    <option value="+44">🇬🇧 +44 (UK)</option>
                                    <option value="+61">
                                      🇦🇺 +61 (Australia)
                                    </option>
                                  </select>

                                  <input
                                    type="tel"
                                    value={mobileNumber}
                                    onChange={(e) =>
                                      setMobileNumber(
                                        e.target.value.replace(/\D/g, "")
                                      )
                                    }
                                    placeholder="Enter mobile number"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                                    maxLength={15}
                                    required
                                  />
                                </div>

                                {mobileError && (
                                  <p className="text-red-500 text-sm">
                                    {mobileError}
                                  </p>
                                )}
                                <button
                                  type="submit"
                                  disabled={isSavingMobile}
                                  className="w-full bg-[#095228] hover:bg-[#1B2537]/90 text-white py-2 rounded-xl font-medium"
                                >
                                  {isSavingMobile ? "Saving..." : "Save"}
                                </button>
                              </form>
                            </div>
                          </div>
                        )}

                        {/* Modal */}
                        {/* {isModalOpen && (



                                                    <div className="fixed inset-0 flex items-center justify-center  bg-[#fff] backdrop-blur bg-opacity-50 z-[9999]">
                                                        <div className="bg-white p-6  md:pl-[8%] md:pr-[8%] md:pb-[6%] rounded-2xl shadow-lg relative">
                                                            <button
                                                                className="hidden md:block absolute top-6 right-6 text-[#fff] hover:text-[#fff] bg-[#095228] rounded-full p-1 pl-2.5 pr-2.5"
                                                                onClick={() => setIsModalOpen(false)}
                                                            >
                                                                ✖
                                                            </button>

                                                            <h2 className="login-title text-base font-medium text-center mt-2 mb-6 px-8">
                                                                OTP Verification
                                                            </h2>

                                                            <form onSubmit={handleSubmitVerify} className="space-y-4 frg-pass-content">

                                                                <div>
                                                                    <label className="text-[14px] text-[#80807F] font-[400] block mt-9 mb-3 text-center">Enter the verification code we just sent to your number +91 94 *******53.&nbsp;
                                                                        {selectedMethod === "email" ? "Email" : "Phone Number"}
                                                                    </label>
                                                                    <input
                                                                        placeholder={selectedMethod === "email" ? "Enter Verification Code" : "Enter Verification Code"}
                                                                        value={code}
                                                                        onChange={(e) => setCode(e.target.value)}
                                                                        className="mb-4 w-full px-3 py-4 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                                                                        required
                                                                    />
                                                                </div>

                                                                <div className="vrfy-code-valid ">
                                                                    <p className=" text-center text-[18px] text-[#BE1F2E] text-lg font-bold">{formatTime(timer)}</p>

                                                                </div>
                                                                <p className=" text-center text-[18px] text-gray-600 ">
                                                                    Didn’t receive a code?{" "}
                                                                    
                                                                    <button
                                                                        onClick={handleSendMobileOTP} // Call new function to resend OTP
                                                                        className="text-[#095228] font-medium hover:underline"
                                                                    >
                                                                        Resend
                                                                    </button>
                                                                </p>
                                                                <button
                                                                    type="submit"
                                                                    onClick={handleVerifyOTP} // Call function to verify OTP

                                                                    className="w-full bg-[#80807F] hover:bg-[#1B2537]/90 text-white py-4 text-[18px] rounded-xl font-medium mb-10"
                                                                >
                                                                    Verify
                                                                </button>
                                                                <button
                                                                    className="md:hidden w-full bg-[#161F28] hover:bg-[#1B2537]/90 text-white py-4 rounded-xl font-medium mb-10"
                                                                    onClick={() => setShowOTPModal(false)}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </form>
                                                        </div>
                                                    </div>
                                                )} */}
                        {showOTPModal && (
                          <div className="fixed inset-0 flex items-center justify-center bg-[#fff] backdrop-blur bg-opacity-50 z-[9999]">
                            <div className="bg-white p-6 rounded-2xl shadow-lg relative">
                              <button
                                className="absolute top-3 right-3 text-[#fff] bg-[#095228] rounded-full p-1"
                                onClick={() => setShowOTPModal(false)}
                              >
                                ✖
                              </button>
                              <h2 className="text-base font-medium text-center mt-2 mb-6 px-8">
                                OTP Verification
                              </h2>
                              <form
                                onSubmit={async (e) => {
                                  e.preventDefault();
                                  setOtpError("");
                                  const token =
                                    sessionStorage.getItem("accessToken") ||
                                    localStorage.getItem("accessToken");
                                  const requestBody = {
                                    email: profile.new_mobile_number, // Use new_mobile_number from profile
                                    otp: otpCode,
                                    verifying: "mobile_number",
                                  };
                                  try {
                                    const res = await fetch(
                                      `${API_BASE_URL}/auth/verify-credential`,
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          token,
                                        },
                                        body: JSON.stringify(requestBody),
                                      }
                                    );
                                    const data = await res.json();
                                    // After successful OTP verification
                                    if (res.ok && data.success) {
                                      toast.success(
                                        "Mobile number verified successfully!"
                                      );
                                      setShowOTPModal(false);

                                      // Fetch latest profile
                                      const token =
                                        sessionStorage.getItem("accessToken") ||
                                        localStorage.getItem("accessToken");
                                      const profileRes = await fetch(
                                        `${API_BASE_URL}/user/profile`,
                                        {
                                          method: "GET",
                                          headers: {
                                            "Content-Type": "application/json",
                                            token,
                                          },
                                        }
                                      );
                                      const profileData =
                                        await profileRes.json();
                                      if (
                                        profileData.success &&
                                        profileData.result
                                      ) {
                                        // Update sessionStorage and local state
                                        sessionStorage.setItem(
                                          "user",
                                          JSON.stringify(profileData.result)
                                        );
                                        localStorage.setItem(
                                          "user",
                                          JSON.stringify(profileData.result)
                                        );
                                        setProfile(profileData.result);
                                        // If you use a local users state, update it too:
                                        // setUsers(profileData.result);
                                      }
                                    } else {
                                      setOtpError(
                                        data.result?.message ||
                                          "Invalid OTP. Please try again."
                                      );
                                    }
                                  } catch (err) {
                                    setOtpError("Error verifying OTP.");
                                  }
                                }}
                                className="space-y-4"
                              >
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                  Enter the verification code sent to your
                                  number: {profile.new_mobile_number}
                                </label>
                                <input
                                  type="text"
                                  value={otpCode}
                                  onChange={(e) => setOtpCode(e.target.value)}
                                  placeholder="Enter OTP"
                                  className="mb-2 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                                  required
                                />
                                {otpError && (
                                  <p className="text-red-500 text-sm">
                                    {otpError}
                                  </p>
                                )}
                                <button
                                  type="submit"
                                  className="w-full bg-[#095228] hover:bg-[#1B2537]/90 text-white py-2 rounded-xl font-medium"
                                >
                                  Verify
                                </button>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>
                      <span className="text-gray-500 block md:hidden">
                        Email ID
                      </span>
                      <div className="bg-white p-3 md:p-5 rounded-[12px] flex flex-wrap justify-between items-center gap-2 shadow-sm">
                        <div className="flex min-w-0">
                          <span className="text-gray-500  w-[200px] tab-title">
                            Email ID
                          </span>
                          <div className="text-black font-[400] flex items-center min-w-0 break-all">
                            {profile?.email || users?.email || "your@email.com"}
                            <span className="ml-1 text-green-500">
                              <span className="w-4 h-4 bg-green-500 text-white rounded-full flex items-center justify-center">
                                <Check className="w-3 h-3" />
                              </span>
                            </span>
                          </div>
                        </div>
                        <button
                          onClick={() => setIsEmailModalOpen(true)}
                          className="text-white bg-[#095228] rounded-[20px] py-2 px-4 text-sm shrink-0 ml-2"
                        >
                          Change
                        </button>
                        {isEmailModalOpen && (
                          <div className="fixed inset-0 flex items-center justify-center bg-[#fff] backdrop-blur bg-opacity-50 z-[9999]">
                            <div className="bg-white p-6 rounded-2xl shadow-lg relative">
                              <button
                                className="absolute top-3 right-3 text-[#fff] bg-[#095228] rounded-full p-1"
                                onClick={() => setIsEmailModalOpen(false)}
                              >
                                ✖
                              </button>
                              <h2 className="login-title text-base font-medium text-center mt-2 mb-6 px-8">
                                Change Email ID
                              </h2>
                              <form
                                onSubmit={async (e) => {
                                  e.preventDefault();
                                  setIsSavingEmail(true);
                                  setEmailError("");
                                  const token =
                                    sessionStorage.getItem("accessToken") ||
                                    localStorage.getItem("accessToken");
                                  const user = JSON.parse(
                                    sessionStorage.getItem("user") ||
                                      localStorage.getItem("user") ||
                                      "{}"
                                  );
                                  if (!newEmail || !user?.id) {
                                    setEmailError(
                                      "Please enter a valid email."
                                    );
                                    setIsSavingEmail(false);
                                    return;
                                  }
                                  try {
                                    // 1. Update email
                                    const response = await fetch(
                                      `${API_BASE_URL}/user/edit-mobile-email`,
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          token,
                                        },
                                        body: JSON.stringify({
                                          // user_id: user.id,
                                          email: newEmail,
                                        }),
                                      }
                                    );
                                    const data = await response.json();
                                    if (response.ok && data.success) {
                                      // 2. Fetch profile to get new_email
                                      const profileRes = await fetch(
                                        `${API_BASE_URL}/user/profile`,
                                        {
                                          method: "GET",
                                          headers: {
                                            "Content-Type": "application/json",
                                            token,
                                          },
                                        }
                                      );
                                      const profileData =
                                        await profileRes.json();
                                      if (
                                        profileData.success &&
                                        profileData.result
                                      ) {
                                        setProfile(profileData.result); // Save profile with new_email
                                        setShowEmailOTPModal(true); // Show OTP modal
                                        setIsEmailModalOpen(false); // Close email change modal
                                      } else {
                                        setEmailError(
                                          "Failed to fetch updated profile."
                                        );
                                      }
                                    } else {
                                      setEmailError(
                                        data.result?.message ||
                                          "Failed to update email."
                                      );
                                    }
                                  } catch (error) {
                                    setEmailError("Error updating email.");
                                  }
                                  setIsSavingEmail(false);
                                }}
                                className="space-y-4"
                              >
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                  Enter new email address:
                                </label>
                                <input
                                  type="email"
                                  value={newEmail}
                                  onChange={(e) => setNewEmail(e.target.value)}
                                  placeholder="your@email.com"
                                  className="mb-2 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                                  required
                                />
                                {emailError && (
                                  <p className="text-red-500 text-sm">
                                    {emailError}
                                  </p>
                                )}
                                <button
                                  type="submit"
                                  disabled={isSavingEmail}
                                  className="w-full bg-[#095228] hover:bg-[#1B2537]/90 text-white py-2 rounded-xl font-medium"
                                >
                                  {isSavingEmail ? "Saving..." : "Save"}
                                </button>
                              </form>
                            </div>
                          </div>
                        )}
                        {showEmailOTPModal && (
                          <div className="fixed inset-0 flex items-center justify-center bg-[#fff] backdrop-blur bg-opacity-50 z-[9999]">
                            <div className="bg-white p-6 rounded-2xl shadow-lg relative">
                              <button
                                className="absolute top-3 right-3 text-[#fff] bg-[#095228] rounded-full p-1"
                                onClick={() => setShowEmailOTPModal(false)}
                              >
                                ✖
                              </button>
                              <h2 className="text-base font-medium text-center mt-2 mb-6 px-8">
                                OTP Verification
                              </h2>
                              <form
                                onSubmit={async (e) => {
                                  e.preventDefault();
                                  setEmailOtpError("");
                                  const token =
                                    sessionStorage.getItem("accessToken") ||
                                    localStorage.getItem("accessToken");
                                  const requestBody = {
                                    email: profile.new_email, // Use new_email from profile
                                    otp: emailOtpCode,
                                    // verifying: "email",
                                  };
                                  try {
                                    const res = await fetch(
                                      `${API_BASE_URL}/auth/verify-credential`,
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          token,
                                        },
                                        body: JSON.stringify(requestBody),
                                      }
                                    );
                                    const data = await res.json();
                                    if (res.ok && data.success) {
                                      toast.success(
                                        "Email verified successfully!"
                                      );
                                      setShowEmailOTPModal(false);

                                      // Fetch latest profile and update UI
                                      const profileRes = await fetch(
                                        `${API_BASE_URL}/user/profile`,
                                        {
                                          method: "GET",
                                          headers: {
                                            "Content-Type": "application/json",
                                            token,
                                          },
                                        }
                                      );
                                      const profileData =
                                        await profileRes.json();
                                      if (
                                        profileData.success &&
                                        profileData.result
                                      ) {
                                        sessionStorage.setItem(
                                          "user",
                                          JSON.stringify(profileData.result)
                                        );
                                        localStorage.setItem(
                                          "user",
                                          JSON.stringify(profileData.result)
                                        );
                                        setProfile(profileData.result);
                                        // If you use a local users state, update it too:
                                        // setUsers(profileData.result);
                                      }
                                    } else {
                                      setEmailOtpError(
                                        data.result?.message ||
                                          "Invalid OTP. Please try again."
                                      );
                                    }
                                  } catch (err) {
                                    setEmailOtpError("Error verifying OTP.");
                                  }
                                }}
                                className="space-y-4"
                              >
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                  Enter the verification code sent to your
                                  email: {profile.new_email}
                                </label>
                                <input
                                  type="text"
                                  value={emailOtpCode}
                                  onChange={(e) =>
                                    setEmailOtpCode(e.target.value)
                                  }
                                  placeholder="Enter OTP"
                                  className="mb-2 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                                  required
                                />
                                {emailOtpError && (
                                  <p className="text-red-500 text-sm">
                                    {emailOtpError}
                                  </p>
                                )}
                                <button
                                  type="submit"
                                  className="w-full bg-[#095228] hover:bg-[#1B2537]/90 text-white py-2 rounded-xl font-medium"
                                >
                                  Verify
                                </button>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>
                      <span className="text-gray-500  block md:hidden">
                        Password
                      </span>
                      <div className="md:bg-white p-0 md:p-5 rounded-[12px] flex flex-col md:flex-row md:items-center md:shadow-sm">
                        <div className="bg-white p-3 md:p-0 rounded-[12px] flex items-center shadow-sm md:shadow-none">
                          <span className="text-gray-500 w-[200px] tab-title hidden lg:block">
                            Password
                          </span>
                          <button
                            className="text-black font-[400] underline"
                            onClick={() => setIsPasswordModalOpen(true)}
                          >
                            Change Password
                          </button>
                        </div>

                        {/* Password Modal */}
                        {isPasswordModalOpen && (
                          <div className="fixed inset-0 flex items-center justify-center bg-[#fff] backdrop-blur bg-opacity-50 z-[9999]">
                            <div className="bg-white p-6 rounded-2xl shadow-lg relative">
                              <button
                                className="absolute top-3 right-3 text-[#fff] bg-[#095228] rounded-full p-1"
                                onClick={() => setIsPasswordModalOpen(false)}
                              >
                                ✖
                              </button>
                              <h2 className="text-base font-medium text-center mt-2 mb-6 px-8">
                                Change Password
                              </h2>
                              <form
                                onSubmit={handleChangePassword}
                                className="space-y-4"
                              >
                                <div className="relative w-full">
                                  <input
                                    type="password"
                                    value={currentPassword}
                                    onChange={(e) =>
                                      setCurrentPassword(e.target.value)
                                    }
                                    placeholder="Enter current password"
                                    className="mb-2 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none pr-10"
                                    required
                                  />
                                </div>
                                <div className="relative w-full">
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    value={newPassword}
                                    onChange={(e) =>
                                      validateNewPassword(e.target.value)
                                    }
                                    placeholder="Enter new password"
                                    className="mb-2 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none pr-10"
                                    required
                                  />
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                    className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                                  >
                                    {showPassword ? (
                                      <EyeOff size={18} />
                                    ) : (
                                      <Eye size={18} />
                                    )}
                                  </button>
                                </div>

                                <div className="password-checkmar text-sm text-gray-600 flex flex-wrap gap-x-6">
                                  <div className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={passwordCriteria.minLength}
                                      readOnly
                                      className="w-4 h-4 accent-green-500"
                                    />
                                    <span>Min 8 characters</span>
                                  </div>
                                  <div className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={passwordCriteria.alphanumeric}
                                      readOnly
                                      className="w-4 h-4 accent-green-500"
                                    />
                                    <span>Alphanumeric</span>
                                  </div>
                                  <div className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={passwordCriteria.specialChar}
                                      readOnly
                                      className="w-4 h-4 accent-green-500"
                                    />
                                    <span>Special character</span>
                                  </div>
                                </div>

                                {passwordError && (
                                  <p className="text-red-500 text-sm">
                                    {passwordError}
                                  </p>
                                )}
                                <button
                                  type="submit"
                                  disabled={isSavingPassword}
                                  className="w-full bg-[#095228] hover:bg-[#1B2537]/90 text-white py-2 rounded-xl font-medium"
                                >
                                  {isSavingPassword ? "Saving..." : "Save"}
                                </button>
                              </form>
                            </div>
                          </div>
                        )}
                      </div>
                      <span className="text-gray-500  block md:hidden">
                        Switch to
                      </span>
                      <div className="bg-white p-3 md:p-5 rounded-[12px] flex  items-center shadow-sm">
                        <span className="text-gray-500  w-[200px] tab-title">
                          Switch to
                        </span>
                        <div className="flex items-center space-x-2">
                          <span
                            className={`font-[400] ${
                              !isPrivate ? "text-black" : "text-gray-400"
                            }`}
                          >
                            Public Account
                          </span>
                          <Switch
                            checked={isPrivate}
                            onChange={handlePrivacyToggle}
                            className={`${
                              isPrivate ? "bg-green-700" : "bg-green-700"
                            } relative inline-flex h-6 w-14 items-center rounded-full transition-all`}
                          >
                            <span
                              className="inline-block h-4 w-6 ml-1 transform bg-white rounded-full translate-x-1 transition-all"
                              style={{
                                transform: isPrivate
                                  ? "translateX(20px)"
                                  : "translateX(0px)",
                              }}
                            />
                          </Switch>
                          <span
                            className={`font-[400] ${
                              isPrivate ? "text-black" : "text-gray-400"
                            }`}
                          >
                            Private Account
                          </span>
                        </div>
                      </div>
                      {userData?.account_type !== "business" && (
                        <>
                          <span className="text-gray-500  block md:hidden">
                            Switch to
                          </span>
                          <div className="bg-white p-3 md:p-5 rounded-[12px] flex  items-center shadow-sm">
                            <span className="text-gray-500  w-[200px] tab-title">
                              Switch to
                            </span>
                            <div className="flex flex-wrap items-center gap-2">
                              <span
                                className={`font-[400] ${
                                  !isPrivate ? "text-black" : "text-gray-400"
                                }`}
                              >
                                Individual Account
                              </span>
                              <Switch
                                checked={isInfluencer}
                                onChange={handleInfluencerToggle}
                                className={`${
                                  isInfluencer ? "bg-green-700" : "bg-green-700"
                                } relative inline-flex h-6 w-14 items-center rounded-full transition-all`}
                              >
                                <span
                                  className="inline-block h-4 w-6 ml-1 transform bg-white rounded-full translate-x-1 transition-all"
                                  style={{
                                    transform: isInfluencer
                                      ? "translateX(20px)"
                                      : "translateX(0px)",
                                  }}
                                />
                              </Switch>
                              <span
                                className={`font-[400] ${
                                  isInfluencer ? "text-black" : "text-gray-400"
                                }`}
                              >
                                Influencer Account
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {userData?.account_type !== "business" && (
                      <VerificationModal
                        isOpen={openModal}
                        onClose={() => getverified(false)}
                        getverified={getverified}
                        userData={userData}
                        pipaanlogo={pipaanlogo}
                        isInfluencer={true}
                        isEligible={isEligible}
                        influencerStatus={influencerStatus}
                        fetchVerificationStatus={() => {
                          fetchUserProfile();
                          fetchVerificationStatus();
                        }}
                      />
                    )}
                  </>
                )}
              </div>

              {/* Two-Factor Authentication Section */}
              <div className="mt-6 p-4 md:p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                <h2 className="text-lg font-semibold mb-4">
                  Two-factor authentication
                </h2>
                <button
                  className="absolute top-4 right-4 md:top-8 md:right-8 p-1 bg-[#09522869] rounded-full"
                  onClick={() => setIsTwoFactorOpen(!isTwoFactorOpen)}
                >
                  <ChevronUp
                    className={`h-4 w-4 text-[#095228] transition-transform ${
                      isTwoFactorOpen ? "rotate-0" : "rotate-180"
                    }`}
                  />
                </button>
                {isTwoFactorOpen && (
                  <>
                    <span className="text-gray-500 mb-2 block md:hidden">
                      Authentication
                    </span>
                    <div className="bg-white p-3 md:p-5 rounded-[12px] flex  items-center shadow-sm">
                      <span className="text-gray-500 w-[200px] tab-title">
                        Authentication
                      </span>
                      <div className="flex items-center space-x-2">
                        <span
                          className={`font-medium ${
                            !isTwoFactorEnabled ? "text-black" : "text-gray-400"
                          }`}
                        >
                          Enable
                        </span>
                        <Switch
                          checked={isTwoFactorEnabled}
                          onChange={setIsTwoFactorEnabled}
                          className={`${
                            isTwoFactorEnabled ? "bg-green-700" : "bg-green-700"
                          } relative inline-flex h-6 w-14 items-center rounded-full transition-all`}
                        >
                          <span
                            className="inline-block h-4 w-6 ml-1 transform bg-white rounded-full translate-x-1 transition-all"
                            style={{
                              transform: isTwoFactorEnabled
                                ? "translateX(20px)"
                                : "translateX(0px)",
                            }}
                          />
                        </Switch>
                        <span
                          className={`font-medium ${
                            isTwoFactorEnabled ? "text-black" : "text-gray-400"
                          }`}
                        >
                          Disable
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/* Blocked Accounts Section */}
              <div className="mt-6 p-4 md:p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                <h2 className="text-lg font-semibold mb-4">Blocked Accounts</h2>
                <button
                  className="absolute top-4 right-4 md:top-8 md:right-8 p-1 bg-[#09522869] rounded-full"
                  onClick={() => setIsBlockedOpen(!isBlockedOpen)}
                >
                  <ChevronUp
                    className={`h-4 w-4 text-[#095228] transition-transform ${
                      isBlockedOpen ? "rotate-0" : "rotate-180"
                    }`}
                  />
                </button>
                {isBlockedOpen && (
                  <>
                    <div className="space-y-3">
                      {blockedUsers.map((friend) => (
                        <div
                          key={friend.id}
                          className="bg-white p-3 md:p-5 rounded-[12px] flex justify-between items-center shadow-sm"
                        >
                          <div className="flex">
                            <img
                              src={friend.User2?.profile_picture_url || userimg}
                              alt="User"
                              className="w-12 h-12 rounded-full"
                            />
                            <div className="pl-4">
                              <p className="titlesemibold font-semibold pb-1">
                                {friend.User2?.first_name}{" "}
                                {friend.User2?.last_name}
                              </p>
                              <p className="text-[12px] text-[#747474] pb-1">
                                @{friend.User2?.username}
                              </p>
                            </div>
                          </div>
                          <button
                            className="text-[#BE1F2E] font-semibold border border-[#BE1F2E] px-3 py-1 rounded-full"
                            onClick={() => handleUnblock(friend.id)} // ✅ Use existing function
                          >
                            Unblock
                          </button>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
              {/* Privacy Centre Section */}
              <div className="mt-6 p-4 md:p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                <h2 className="text-lg font-semibold mb-4">Privacy Centre</h2>
                <button
                  className="absolute top-4 right-4 md:top-8 md:right-8 p-1 bg-[#09522869] rounded-full"
                  onClick={() => setIsPrivacyOpen(!isPrivacyOpen)}
                >
                  <ChevronUp
                    className={`h-4 w-4 text-[#095228] transition-transform ${
                      isPrivacyOpen ? "rotate-0" : "rotate-180"
                    }`}
                  />
                </button>
                {isPrivacyOpen && (
                  <>
                    <div className="space-y-3">
                      {[
                        {
                          label: "Phone Number",
                          value: users?.mobile_number || "+91-XXXX-XXXXXX",
                          field: "phone_privacy",
                        },
                        {
                          label: "Email ID",
                          value: users?.email || "your@email.com",
                          field: "email_privacy",
                        },

                        // { label: "Who can see your friends list on your profile?" },
                        {
                          label:
                            "Who can see the people, Pages and lists you follow?",
                          field: "follower_privacy",
                        },
                        // { label: "Who can see your future Feeds?", field: "post_privacy" },
                        {
                          label: "Who can see your future Stories?",
                          field: "story_privacy",
                        },
                        { label: "Who can tag you?", field: "tag_privacy" },
                        {
                          label: "Who can see you're online?",
                          field: "online_privacy",
                        },
                      ].map((setting, index) => (
                        <div
                          key={index}
                          className={`bg-white p-3 md:p-5 rounded-[12px] flex justify-between items-center shadow-sm ${
                            setting.value ? "hidden sm:flex" : "flex"
                          }`}
                        >
                          <div className="flex w-full justify-between">
                            <span className="text-[#494949]">
                              {setting.label}
                            </span>
                            {setting.value && (
                              <span className="text-black font-[400] text-[14px] flex">
                                {setting.value}{" "}
                                <span className="w-4 h-4 ml-2 bg-green-500 text-white rounded-full flex items-center justify-center">
                                  <Check className="w-3 h-3" />
                                </span>
                              </span>
                            )}
                            <select
                              className="text-black font-medium bg-transparent border-none outline-none"
                              value={privacySettings[setting.field]}
                              onChange={async (e) => {
                                const newValue = e.target.value;
                                const field = setting.field;
                                const privacyId =
                                  sessionStorage.getItem("privacyId") ||
                                  localStorage.getItem("privacyId");
                                // 🔹 update local state immediately so UI changes without waiting for API
                                setPrivacySettings((prev) => ({
                                  ...prev,
                                  [field]: newValue,
                                }));
                                try {
                                  await handlePrivacyChange(field, newValue);
                                } catch (err) {
                                  console.error("Error updating privacy:", err);
                                }
                              }}
                            >
                              {["phone_privacy", "email_privacy"].includes(
                                setting.field
                              ) ? (
                                <>
                                  <option value="public">Public</option>
                                  <option value="private">Only me</option>
                                  <option value="friends">Friends</option>
                                </>
                              ) : setting.field === "tag_privacy" ? (
                                <>
                                  <option value="public">Everyone</option>
                                  <option value="private">People I follow</option>
                                  <option value="none">No one</option>
                                </>
                              ) : (
                                <>
                                  <option value="public">Public</option>
                                  <option value="private">Private</option>
                                </>
                              )}
                            </select>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
              {/* Legal Section (Privacy Policy and Terms & Conditions from the admin CMS) */}
              <div className="mt-6 p-4 md:p-8 bg-[#F4F4F4] rounded-2xl shadow-lg relative">
                <h2 className="text-lg font-semibold mb-4">Legal</h2>
                <button
                  className="absolute top-4 right-4 md:top-8 md:right-8 p-1 bg-[#09522869] rounded-full"
                  onClick={() => setIsPolicyOpen(!isPolicyOpen)}
                >
                  <ChevronUp
                    className={`h-4 w-4 text-[#095228] transition-transform ${
                      isPolicyOpen ? "rotate-0" : "rotate-180"
                    }`}
                  />
                </button>
                {isPolicyOpen && (
                  <>
                    <div className="space-y-3">
                      <AccordionItem title="Privacy Policy">
                        <LegalDocumentPreview slug={CMS_SLUGS.PRIVACY_POLICY} path="/privacy-policy" />
                      </AccordionItem>
                      <AccordionItem title="Terms & Conditions">
                        <LegalDocumentPreview slug={CMS_SLUGS.TERMS} path="/terms-conditions" />
                      </AccordionItem>
                    </div>
                  </>
                )}
              </div>
              {/* Delete Account Section */}
              <div className="mt-6 p-4 md:p-8 bg-[#F4F4F4] rounded-2xl shadow-lg">
                <h2 className="text-lg font-semibold mb-4">Delete Account</h2>
                <div className="bg-white p-3 md:p-5 rounded-[12px] flex flex-col md:flex-row md:items-center md:justify-between gap-3 shadow-sm">
                  <span className="text-gray-500">
                    Permanently delete your account and personal data.
                  </span>
                  <button
                    type="button"
                    className="shrink-0 rounded-lg bg-red-600 px-4 py-2 text-white"
                    onClick={() => setIsDeleteAccountOpen(true)}
                  >
                    Delete my account
                  </button>
                </div>
                {isDeleteAccountOpen && (
                  <DeleteAccountModal
                    isSocialLogin={userData?.is_social_login}
                    onClose={() => setIsDeleteAccountOpen(false)}
                  />
                )}
              </div>
            </div>
            {/* <Viewpost /> */}
            <RightResponsivesidebar />
          </div>
          {/* Right Sidebar */}
          <Rightsidebar />
        </main>
      </main>
    </div>
  );
}
